module.exports = __webpack_public_path__ + "static/media/mention-icon.43bb1d9f.svg";